import { extractSensorValue } from '@atcreate-inc/sigfox-decoder/dist/processors/sensors'
import { SensorProductIdLookup, SensorType } from '../common/enums'

// 12-bit raw value the RIC sends for an invalid reading
const INVALID_READING = 0xfff

// Volume per reading depends on the schedule interval, which the Messages page
// doesn't know, so these keep the plain scale/offset reading.
const NEEDS_SCHEDULE_FREQUENCY = new Set<SensorType>([
  SensorType.Badgermeter220BR,
  SensorType.BadgermeterSDI,
  SensorType.DEMPaddleWheel,
])

export interface SensorConversionConfig {
  sensorProductId?: number
  conversionScale?: number
  conversionOffset?: number
}

/**
 * Convert a raw 12-bit SCHD reading the way the ingestion pipeline does: with
 * the product's own converter from sigfox-decoder (the VH400's piecewise VWC
 * curve, Dwyer's volts-to-PSI, and so on). Falls back to scale/offset for
 * products without a converter. Null for an invalid (0xFFF) reading.
 */
export function convertSensorReading(rawValue: number, config: SensorConversionConfig): number | null {
  if (rawValue === INVALID_READING) return null

  const scale = config.conversionScale ?? 1
  const offset = config.conversionOffset ?? 0
  const linear = rawValue * scale + offset

  const sensorType = config.sensorProductId ? SensorProductIdLookup[config.sensorProductId] : undefined
  if (!sensorType || NEEDS_SCHEDULE_FREQUENCY.has(sensorType)) return linear

  const converted = extractSensorValue({ sensorType, conversion: { scale, offset } } as any, rawValue, 0)
  return converted === undefined || !Number.isFinite(converted) ? linear : converted
}
